import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import { TeamTable } from './widgets/team-table/TeamTable'
import { useTranslation } from 'react-i18next'

export const TeamPage = () => {
  const { t } = useTranslation()

  return (
    <CommonMainPage title={t('navigation.team')}>
      <section className='h-full'>
        <TeamTable />
      </section>
    </CommonMainPage>
  )
}
